export const titles = ['¿Con qué equipaje querés viajar?'];
export const messages = {
  hand: {
    free:
      'Podés agregar equipaje de mano sin cargo siendo un total del vuelo de [total].',
    notFree:
      'Podés agregar solo equipaje de mano por [total_difference] siendo un total del vuelo de [total].',
    better:
      'Hay una mejor opción con equipaje de mano por un total de [total].',
  },
  only_hold: {
    free:
      'Podés agregar solo equipaje de bodega sin cargo siendo un total del vuelo de [total].',
    notFree:
      'Podés agregar solo equipaje de bodega por [total_difference] siendo un total del vuelo de [total].',
    better:
      'Hay una mejor opción solo con equipaje de bodega por un total de [total].',
  },
  hold: {
    free:
      'Podés agregar equipaje completo sin cargo siendo un total del vuelo de [total].',
    notFree:
      'Podés agregar equipaje completo por [total_difference] siendo un total del vuelo de [total].',
    better:
      'Hay una mejor opción con equipaje completo por un total de [total].',
  },
};
